import React from 'react';
import styled, { css } from 'styled-components';

import VerticalIcon from '@/assets/svg/vertical.svg';
import HorizontalIcon from '@/assets/svg/horizontal.svg';
import { colors } from '@/constants/theme';

import { CarViewToggleProps } from './types';

function CarViewToggle({
  view,
  color = colors.black200,
  onChange,
}: CarViewToggleProps) {
  return (
    <Component>
      <IconWrapper
        color={color}
        isActive={view === 'portrait'}
        onClick={() => onChange?.('portrait')}
      >
        <VerticalIcon />
      </IconWrapper>
      <IconWrapper
        color={color}
        isActive={view === 'landscape'}
        onClick={() => onChange?.('landscape')}
      >
        <HorizontalIcon />
      </IconWrapper>
    </Component>
  );
}

export default CarViewToggle;

const Component = styled.div`
  display: flex;
`;

const IconWrapper = styled.button<{ isActive: boolean; color: string }>`
  width: 40px;
  height: 40px;
  opacity: 0.5;

  &:not(:first-child) {
    margin-left: 10px;
  }

  ${({ isActive }) =>
    isActive &&
    css`
      opacity: 1;
    `}

  ${({ color }) =>
    color &&
    css`
      svg {
        rect {
          stroke: ${color};

          &:not(:first-child) {
            fill: ${color};
          }
        }

        circle {
          fill: ${color};
        }
      }
    `}
`;
